"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCategories = exports.ContentTypes = exports.MessageSenders = void 0;
var MessageSenders;
(function (MessageSenders) {
    MessageSenders["AGENT"] = "agent";
    MessageSenders["USER"] = "user";
    MessageSenders["CHATBOT"] = "chatbot";
    MessageSenders["SYSTEM"] = "system";
})(MessageSenders || (exports.MessageSenders = MessageSenders = {}));
var ContentTypes;
(function (ContentTypes) {
    ContentTypes["LINK"] = "link";
    ContentTypes["BUTTON"] = "button";
    ContentTypes["INPUT"] = "input";
    ContentTypes["LIST_ORDERS"] = "list-orders";
    ContentTypes["LIST_ORDERS_WITH_AIRPORT_TRANSFERS"] = "list-orders-with-airport-transfers";
    ContentTypes["LIST_FLIGHT_ORDERS"] = "list-flight-orders";
    ContentTypes["FINE_PRINT_MODAL"] = "fine-print-modal";
    ContentTypes["LIST_INCLUSIONS"] = "list-inclusions";
    ContentTypes["LIST_ORDER_ITEMS"] = "list-order-items";
    ContentTypes["OTP_LOGIN"] = "otp-login";
    ContentTypes["MESSAGE_TRANSFER"] = "message-transfer";
})(ContentTypes || (exports.ContentTypes = ContentTypes = {}));
var ContentCategories;
(function (ContentCategories) {
    ContentCategories["AIRPORT_TRANSFERS"] = "airportTransfers";
    ContentCategories["AIRPORT_TRANSFERS_PURCHASE"] = "airportTransfersPurchase";
    ContentCategories["AIRPORT_TRANSFERS_BOOK"] = "airportTransfersBook";
    ContentCategories["AIRPORT_TRANSFERS_ORDER_LIST"] = "airportTransfersOrderList";
    ContentCategories["AIRPORT_TRANSFERS_EMPTY"] = "airportTransfersEmpty";
    ContentCategories["AIRPORT_TRANSFERS_MISSING"] = "airportTransfersMissing";
    ContentCategories["AIRPORT_TRANSFERS_FORM"] = "airportTransfersForm";
    ContentCategories["CANCEL"] = "cancel";
    ContentCategories["CHAT_AGENT"] = "chatAgent";
    ContentCategories["CHAT_NEW"] = "chatNew";
    ContentCategories["CHAT_LESA"] = "chatLesa";
    ContentCategories["CHAT_RECENT"] = "chatRecent";
    ContentCategories["CRUISE_ENQUIRY"] = "cruiseEnquiry";
    ContentCategories["CONFIRM"] = "confirm";
    ContentCategories["DOWNLOAD_TAX_INVOICE"] = "downloadTaxInvoice";
    ContentCategories["FLIGHT_ORDER_LIST"] = "flightOrderList";
    ContentCategories["FLIGHTS_ELECTRONIC_TICKETS"] = "flightsElectronicTickets";
    ContentCategories["FREQUENT_FLYER"] = "frequentFlyer";
    ContentCategories["HOTEL_ENQUIRY"] = "hotelEnquiry";
    ContentCategories["ORDER"] = "order";
    ContentCategories["ORDER_CANCEL"] = "orderCancel";
    ContentCategories["ORDER_ADD_DATES"] = "orderAddDates";
    ContentCategories["ORDER_CHANGE_DATES"] = "orderChangeDates";
    ContentCategories["ORDER_CHANGE_ROOM"] = "orderChangeRoom";
    ContentCategories["ORDER_FINE_PRINT"] = "orderFinePrint";
    ContentCategories["ORDER_INCLUSIONS"] = "orderInclusions";
    ContentCategories["ORDER_ITEMS_LIST"] = "orderItemList";
    ContentCategories["ORDER_LIST"] = "orderList";
    ContentCategories["ORDER_NEW"] = "orderNew";
    ContentCategories["ORDER_RESEND_CONFIRMATION"] = "orderResendConfirmation";
    ContentCategories["OTHER"] = "other";
    ContentCategories["PAYMENT_ISSUES"] = "paymentIssues";
    ContentCategories["REDIRECT_MY_ESCAPES"] = "redirectMyEscapes";
    ContentCategories["REQUEST_AGENT_CALLBACK"] = "requestAgentCallback";
    ContentCategories["TOUR_ENQUIRY"] = "tourEnquiry";
    ContentCategories["USER_EMAIL"] = "userEmail";
    ContentCategories["USER_PHONE"] = "userPhone";
    ContentCategories["USER_LOG_IN"] = "userLogIn";
    ContentCategories["USER_LOG_IN_ISSUE"] = "userLogInIssue";
    ContentCategories["USER_LOG_IN_PHONE"] = "userLogInPhone";
    ContentCategories["USER_PASSWORD_RESET"] = "userPasswordReset";
    ContentCategories["USER_UPDATE"] = "userUpdate";
    ContentCategories["USER_UPDATE_EMAIL"] = "userUpdateEmail";
    ContentCategories["USER_UPDATE_NAME"] = "userUpdateName";
    ContentCategories["USER_UPDATE_PHONE"] = "userUpdatePhone";
    ContentCategories["USER_UPDATE_SUBSCRIPTION"] = "userUpdateSubscription";
    ContentCategories["LUX_PLUS_PRIORITY_SUPPORT"] = "luxPlusPrioritySupport";
    ContentCategories["CAR_HIRE"] = "carHire";
    ContentCategories["INSURANCE"] = "insurance";
})(ContentCategories || (exports.ContentCategories = ContentCategories = {}));
